import Swiper from "swiper";
import Velocity from 'velocity-animate';

export default function initTopic () {
    const topic = document.querySelectorAll('.topic');
    if (!topic.length) return;

    // slider for products
    const target = document.querySelector('.topic__products');

    if(target) {

        const config = {
            slidesPerView: 'auto',
            initialSlide: 0,
            centeredSlides: true,
            autoHeight: true,
            breakpoints: {
                1001: {
                    slidesPerView: 3,
                    autoHeight: true,
                    centeredSlides: false
                }
            },
            pagination: {
                el: '.topic__products .swiper-pagination',
                clickable: true,
            }
        }

        let topicProductsSlider = new Swiper('.topic__products', config);
        window.addEventListener('orientationchange', function () {
            if (topicProductsSlider && topicProductsSlider instanceof Swiper) {
                topicProductsSlider.destroy(true, true);
                setTimeout(() => {
                    topicProductsSlider = new Swiper('.topic__products', config);
                }, 100);
            }
        });
    }

    // social icons fix
    const socialIcons = document.querySelector('.topic__info-social');
    const bannerHight = document.querySelector('.topic__banner')?.offsetHeight;
    const mainHight = document.querySelector('main')?.offsetHeight;

    if ( socialIcons &&  bannerHight && mainHight ) {
        const topLine =  bannerHight * 1.5;
        const bottomLine =  mainHight * 1.1;

        window.addEventListener('scroll', function() {
            if (document.documentElement.scrollTop > bottomLine) {
                socialIcons.classList.add('_hidden');
            } else if (document.documentElement.scrollTop > topLine) {
                socialIcons.classList.add('_fixed');
                socialIcons.classList.remove('_hidden');
            } else {
                socialIcons.classList.remove('_fixed');
                socialIcons.classList.remove('_hidden');
            }
        }, { passive: true });
    }

    // add time reading
    const articleTextLength = document.querySelectorAll('.topic__article')[0].textContent.length;
    let articleTimeRead = document.querySelector('#topic__info-timing__time');

    if ( articleTextLength && articleTimeRead ) {
        articleTimeRead.innerHTML = '&nbsp;' + Math.round(articleTextLength / 1000) + '&nbsp;';
    }

    // table horizontal scroll
    const scrollBar = document.querySelectorAll('.scroll-bar');

    if (scrollBar.length) {
        const scrollContainer = document.querySelector('.scroll-bar__target');
        const scrollBarProgress = document.querySelector('.scroll-bar__scroll');

        scrollContainer.parentElement.style.position = 'relative';
        scrollContainer.addEventListener('scroll', function () {
            let scrollLeft = scrollContainer.scrollLeft;
            let scrollWidth = scrollContainer.scrollWidth;
            let percent = scrollLeft / (scrollWidth - scrollContainer.clientWidth) * 67;
            scrollBarProgress.style.left = percent + '%';
        }, { passive: true });
    }


    // add content linked list
    const anchors = document.querySelectorAll('.topic__anchor');

    if (anchors.length) {

        let contentContainer = document.querySelector('.topic__content-spot');
        let contentHtml = ''
        let contentList = '';
        let topicAnchors = [];

        const anchorsArray = Array.from(anchors).map(obj => ({
            tag: obj.tagName,
            text: obj.innerText
        }));

        contentHtml = '<div class="topic__content">';
        contentHtml += '<div class="topic__content-title">Содержание</div>';
        contentHtml += '<div class="topic__content-list">';

        let headingNumberCount = 1;
        let titleNumberCount = 1;
        anchorsArray.forEach((el, index) => {
            let text = `<div class="topic__content-list__item-wrapper">`;
            text += `<a href="#topic__anchor-${index + 1}" `;
            text += `class="topic__content-list__item topic-anchor`;
            text += el.tag === 'H2' ? `">${headingNumberCount}` : ` _ind">${headingNumberCount - 1}. ${titleNumberCount}`;
            text += `. ${el.text}</a>`;
            text += `</div>`
            contentList += text;

            if (el.tag === 'H2') {
                ++headingNumberCount;
                titleNumberCount = 1;
            } else {
                ++titleNumberCount;
            }
        });

        contentHtml += contentList;
        contentHtml += '</div></div>';
        contentContainer.insertAdjacentHTML( 'beforeend', contentHtml );

        topicAnchors = document.querySelectorAll('.topic-anchor');

        if (!topicAnchors.length) return;
        [...topicAnchors].map(a => {
            a.addEventListener('click', function (e) {
                e.preventDefault();
                const target = document.querySelector(this.hash);
                Velocity(
                    target,
                    'scroll',
                    {
                        duration: 700,
                        offset: document.querySelector('.header') ? -document.querySelector('.header')?.offsetHeight : 0,
                    }
                );
            })
        });
    }
}
